/* eslint-disable prettier/prettier */
/* eslint-disable no-negated-condition */
/* eslint-disable no-use-before-define */
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { CloseIcon } from "@twilio-paste/icons/esm/CloseIcon";
import { useDispatch, useSelector } from "react-redux";

import { changeEngagementPhase } from "../store/actions/genericActions";
import { containerStyles, titleStyles, closeButtonStyles } from "./styles/Header.styles";
import { AppState, EngagementPhase } from "../store/definitions";

export const Header = () => {
    const conversationState = useSelector((state: AppState) => state.chat.conversationState);
    const dispatch = useDispatch();
    const handleSubmit = (): void => {
        dispatch(changeEngagementPhase({ phase: EngagementPhase.UserEnding }));
    };

    return (
        <Box as="header" {...containerStyles}>
            {/* <img
                src="https://staging.liberon.fr/wp-content/uploads/2025/11/LIBERON_LOGO_ONLY_K_600-1536x712.jpg"
                alt="logo Liberon"
                height="30px"
            /> */}
            <Text as="span" {...titleStyles}>
                Echangez avec un conseiller Libéron
            </Text>

            {conversationState === "active" ? (
                
                <Box as="button" data-test="close-point-button" onClick={handleSubmit} {...closeButtonStyles} title="Terminer la conversation">
                    <CloseIcon decorative={false} title="Terminer la conversation" color="colorTextLink" />
                </Box>
            ) : (
                <></>
            )}
        </Box>
    );
};
